<template>
  <Teleport to="body">
    <div class="fixed top-4 right-4 z-[100] space-y-2 max-w-sm">
      <TransitionGroup name="toast">
        <div
          v-for="n in notifications"
          :key="n.id"
          class="flex items-start gap-2 p-3 rounded-lg shadow-lg text-sm border"
          :class="typeClass(n.type)"
        >
          <span class="flex-1">{{ n.message }}</span>
          <button @click="store.remove(n.id)" class="opacity-60 hover:opacity-100 text-xs">x</button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { useNotificationStore } from '../../stores/notifications'

const store = useNotificationStore()
const notifications = computed(() => store.notifications)

function typeClass(type) {
  return {
    success: 'bg-green-900/90 border-green-700 text-green-200',
    error: 'bg-red-900/90 border-red-700 text-red-200',
    warning: 'bg-yellow-900/90 border-yellow-700 text-yellow-200',
    info: 'bg-blue-900/90 border-blue-700 text-blue-200',
  }[type] || 'bg-gray-800 border-gray-600 text-gray-200'
}
</script>

<style scoped>
.toast-enter-active { transition: all 0.3s ease-out; }
.toast-leave-active { transition: all 0.2s ease-in; }
.toast-enter-from { opacity: 0; transform: translateX(100%); }
.toast-leave-to { opacity: 0; transform: translateX(100%); }
</style>
